import PropTypes from 'prop-types';
import React from 'react';
import Option from './option';

class Row extends React.Component {
  componentDidMount() {
    this.addChosen();
    $(this.refs.categorySelect).change(() => this.categorySelected());
  }

  componentDidUpdate() {
    $(this.refs.categorySelect).trigger('liszt:updated');
  }

  categorySelected() {
    // trigger blur manually because Chosen sucks and the pg matcher needs it
    $(this.refs.categorySelect).blur();
    this.props.categorySelected(this.refs.categorySelect.value, this.props.categoryIndex);
  }

  addChosen() {
    $(this.refs.categorySelect).chosen({
      placeholder_text_single: ' ',
      placeholder_text_multiple: ' ',
      search_contains: true,
    });
    this.chosenUI().find('.chzn-search input')
      .attr('placeholder', I18n.t('categorySelect.searchPlaceholder'));
  }

  removeChosen() {
    $(this.refs.categorySelect).show().removeClass('chzn-done');
    $(this.refs.categorySelect).next()
      .removeData()
      .remove();
  }

  chosenUI() {
    return $(this.refs.categorySelect).next();
  }

  // when null is returned jsx doesn't render that attribute
  isRequired() {
    if (this.props.categoryIndex === 0) {
      return true;
    }
    return null;
  }

  promptText() {
    if (this.props.categoryIndex === 0) {
      return I18n.t('categorySelect.findCategory');
    }
    return I18n.t('categorySelect.optionalFindCategory');
  }

  render() {
    return (
      <div>
        <select
          disabled={this.props.disabled}
          value={this.props.categoryIdSelected}
          ref="categorySelect"
          className="wide"
          name={this.props.inputName}
          required={this.isRequired()}
          data-force-validation={this.isRequired()}
          data-pg-match="required"
          onChange={() => this.categorySelected()}
        >
          <option value="">{this.promptText()}</option>
          {this.props.categories.map(category =>
            <Option key={category.id} category={category} />)}
        </select>
      </div>
    );
  }
}

Row.propTypes = {
  categorySelected: PropTypes.func.isRequired,
  showAddButton: PropTypes.bool,
  showRemoveButton: PropTypes.bool,
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  categoryIndex: PropTypes.number,
  disabled: PropTypes.bool,
  categoryIdSelected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  inputName: PropTypes.string.isRequired,
};

export default Row;
